import { Button, Modal, Tooltip } from "@material-ui/core";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useMemo, useState } from "react";
import { Edit3 } from "react-feather";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { fdelete, fpatch } from "../../../API/callsAPI";
import { renderFieldContent } from "../../Utilities/CustomTableForAllTrackables/CustomTableBodyForAllTrackables";
import AssetVersionEditVersionModal from "../AssetsVersionsPageModal/AssetVersionEditVersionModal";
import DeleteModal from "../../Utilities/DeleteModal/DeleteModal.component";
import useStyles from "./AssetVersionCustomTable.styles";

const AssetVersionCustomTable = ({
  assetVersionList,
  projectId,
  statusList,
  updateRefreshCounter,
  setSnackValue,
  allFieldsConfig,
  handleAssetDetailModalState,
  taskList,
  fetchTasks,
  dragScreen,
  handleDragScreen,
  setDragFileEnterModal,
}) => {
  const classes = useStyles();
  const history = useHistory();

  const [isEditAssetVerisonModalOpen, setEditAssetVersionModalOpen] = useState({
    open: false,
    data: null,
  });

  const [isDeleteAssetVerisonModalOpen, setDeleteAssetVersionModalOpen] =
    useState({
      open: false,
      data: null,
    });

  function handleEditAssetVersionModalState(e, data) {
    e?.stopPropagation();
    setEditAssetVersionModalOpen({
      open: true,
      data: data,
    });
  }

  function handleDeleteAssetVersionModalState(e, data) {
    e?.stopPropagation();
    setDeleteAssetVersionModalOpen({
      open: true,
      data: data,
    });
  }

  const handleAssetVersionDelete = async () => {
    try {
      await fdelete({
        url: `trackables/asset-version/${isDeleteAssetVerisonModalOpen.data?.id}/`,
      });
      updateRefreshCounter();
      setDeleteAssetVersionModalOpen({
        open: false,
        data: null,
      });
      setEditAssetVersionModalOpen({
        open: false,
        data: null,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const rows = useMemo(
    () =>
      (assetVersionList?.results ?? []).map((res) => ({
        id: res.id,
        ...res,
      })),
    [assetVersionList?.results],
  );

  const handleValueChange = async (fieldName, value, id) => {
    try {
      const res = await fpatch({
        url: `trackables/asset-version/v2/${id}/`,
        data: {
          [fieldName]: value,
        },
      });
      if (res.status === 200 || res.status === 201) {
        updateRefreshCounter();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRowClick = (params, event) => {
    handleAssetDetailModalState(params.row);
  };

  const columns = [
    ...(allFieldsConfig ?? []).map((field) => ({
      field: field.name,
      headerName: field.label || field.name,
      minWidth: 190,
      flex: 1,
      sortable: true,
      renderCell: (params) => (
        <div
          style={{
            width: "100%",
            minHeight: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          {renderFieldContent({
            field,
            props: { data: params.row },
            handleValueChange: (fieldName, value) =>
              handleValueChange(fieldName, value, params.row.id),
            index: 0,
            statusUrl: `trackables/asset-version/${params.row.id}/`,
            statusList,
            updateRefreshCounter,
          })}
        </div>
      ),
    })),
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 190,
      sortable: false,
      renderCell: (params) => {
        const data = params.row;
        return (
          <Tooltip title="Edit Asset" placement="top">
            <Button
              id="editAssetVersion"
              className={classes.inlineButtons}
              onClick={(e) => handleEditAssetVersionModalState(e, params.row)}
            >
              <Edit3 size={18} />
            </Button>
          </Tooltip>
        );
      },
    },
  ];

  return (
    <Box
      className={classes.assetsTableContainer}
      sx={{
        height:
          assetVersionList?.count > 50
            ? "calc(100vh - 230px)"
            : "calc(100vh - 200px)",
        width: "100%",
        overflowX: "auto",
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        disableSelectionOnClick
        onRowClick={handleRowClick}
        hideFooter
        sx={{
          width: "max-content",
          minWidth: "100%",
          border: "none",
          bgcolor: "transparent",
          "& .MuiDataGrid-root": {
            background: "#1B1D28 !important",
            color: "#606479 !important",
          },
          "& .MuiDataGrid-cell": {
            borderTop: "1px solid #606479 !important",
            alignItems: "center",
          },
          "& .MuiDataGrid-row": {
            cursor: "pointer",
            backgroundColor: "#1B1D28",
            color: "#f9f9f9",
            // "&:hover": {
            //   backgroundColor: "#606479",
            // },
          },
          "& .MuiDataGrid-main": {
            minWidth: "max-content",
          },
          "& .MuiDataGrid-virtualScroller": {
            overflowX: "auto",
          },
          "& .MuiDataGrid-window": {
            overflowX: "auto",
          },
          "& .MuiDataGrid-footerContainer": {
            display: "none",
          },
          //
          "& .MuiDataGrid-container--top [role='row'], & .MuiDataGrid-container--bottom [role='row']":
            {
              backgroundColor: "#1B1D28 !important",
              borderColor: "#606479",
              borderTop: "1px solid #606479",
              padding: "0px",
            },

          "--DataGrid-rowBorderColor": "#606479",
          "& .MuiDataGrid-columnHeaders": {
            color: "#606479",
            fontSize: {
              xs: "8px",
              sm: "10px",
              md: "12px",
              lg: "14px",
              xl: "16px",
            },
          },
        }}
        slots={{
          noRowsOverlay: () => (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              No shots found.
            </Box>
          ),
        }}
      />
      <Modal
        className={classes.assetsVersionModals}
        open={isEditAssetVerisonModalOpen.open}
        onClose={(e) => {
          setEditAssetVersionModalOpen({
            open: false,
            data: null,
          });
          e.stopPropagation();
        }}
      >
        <AssetVersionEditVersionModal
          taskList={taskList}
          fetchTasks={fetchTasks}
          status={statusList}
          data={isEditAssetVerisonModalOpen.data}
          projectId={projectId}
          handleEditAssetVersionModalState={(e) => {
            setEditAssetVersionModalOpen({
              open: false,
              data: null,
            });
          }}
          handleDeleteAssetVersionModalState={
            handleDeleteAssetVersionModalState
          }
          updateRefreshCounter={updateRefreshCounter}
          dragScreen={dragScreen}
          handleDragScreen={handleDragScreen}
          setDragFileEnterModal={setDragFileEnterModal}
          customFields={assetVersionList.custom_fields}
        />
      </Modal>

      <Modal
        className={classes.assetsVersionModals}
        open={isDeleteAssetVerisonModalOpen.open}
        onClose={(e) => {
          setDeleteAssetVersionModalOpen({
            open: false,
            data: null,
          });
        }}
      >
        <DeleteModal
          type="assets version"
          name={isDeleteAssetVerisonModalOpen.data?.name}
          handleCloseDeleteModal={() => {
            setDeleteAssetVersionModalOpen({
              open: false,
              data: null,
            });
          }}
          handleDelete={handleAssetVersionDelete}
        />
      </Modal>
    </Box>
  );
};

export default AssetVersionCustomTable;
